import { defaultTheme, useStyletron } from '@thanx/uikit/theme'
import React from 'react'
import Nav from 'react-bootstrap-five/Nav'
import { history } from 'store'

type SubTabProps = {
  tabKey: string
  name: string
  active: boolean
}

const SubTab: React.FC<SubTabProps> = ({ tabKey, name, active }) => {
  const [css] = useStyletron()

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    // Convert tabKey to path segment (remove app_navigation_ prefix if present)
    const pathSegment = tabKey.replace('app_navigation_', '')
    history.push(`/brand_content/app_navigation/${pathSegment}`)
  }

  return (
    <Nav.Item>
      <Nav.Link
        onClick={handleClick}
        className={`pl-xl pr-xs body-text-4 ${
          active
            ? `grey-90 bold ${css({
                backgroundColor: '#D8E6F0', // this color is not in our color palette
              })}`
            : 'grey-70'
        } ${css({
          ':focus': {
            color: defaultTheme.colors.grey90,
          },
          cursor: 'pointer',
        })}`}
      >
        {name}
      </Nav.Link>
    </Nav.Item>
  )
}

export default SubTab
